<!-- multiselect -->
<!-- <p-multiSelect
 <p-multiSelect
  class="filter-class"
  *ngIf="config.type === 'multiselect'"
  [options]="config.options"
  [(ngModel)]="value"
  [optionLabel]="config.optionLabel || 'label'"
  [placeholder]="config.label || 'Select...'"
  [filter]="true"
  (onChange)="onValueChange(value)"
  [showClear]="true"
  [showToggleAll]="false"
  display="comma"
  size="small"
  [maxSelectedLabels]="0"
  selectedItemsLabel="{0} selected"
>
</p-multiSelect> -->

<!-- <p-multiSelect
  name="responsibleCountry"
  [(ngModel)]="value"
  [options]="config.options"
  [optionLabel]="config.optionLabel || 'label'"
  [placeholder]="config.label || 'Select...'"
  display="chip"
  [filter]="true"
  required
  #assignedCountry="ngModel"
  [overlayOptions]="getOverlayOptions()"
  (click)="onDropdownOpen()"
  (onPanelHide)="onDropdownClose()"
  panelStyleClass="multiselect-panel"
> -->

<p-multiSelect
  name="responsibleCountry"
  *ngIf="config.type === 'multiselect'"
  [(ngModel)]="value"
  [options]="config.options"
  [optionLabel]="config.optionLabel || 'label'"
  [placeholder]="config.label || 'Select...'"
  (onChange)="onValueChange(value)"
  (onClear)="onClearValue()"
  (onFilter)="onOptionsFilter($event)"
  [filter]="true"
  display="comma"
  [showClear]="true"
  #assignedCountry="ngModel"
  panelStyleClass="custom-multiselect-overlay"
  size="small"
  [maxSelectedLabels]="0"
  selectedItemsLabel="{0} selected"
  styleClass="custom-multiselect"
  [virtualScroll]="!!config.virtualScroll"
  [virtualScrollItemSize]="config.virtualScrollItemSize || 40"
  [lazy]="!!config.lazy"
  [virtualScrollOptions]="config.lazy ? virtualScrollOptions : undefined"
>
</p-multiSelect>

<!-- dropdown -->
<p-dropdown
  class="filter-class"
  *ngIf="config.type === 'dropdown'"
  [options]="config.options"
  [(ngModel)]="value"
  [optionLabel]="config.optionLabel || 'label'"
  [placeholder]="config.label || 'Select...'"
  (onChange)="onValueChange(value)"
>
</p-dropdown>

<!-- daterange -->
<div *ngIf="config.type === 'daterange'" class="flex gap-2 filter-class">
  <p-datePicker
    selectionMode="range"
    [(ngModel)]="value"
    iconDisplay="input"
    placeholder="{{ config.label || 'Select…' }}"
    (ngModelChange)="onValueChange($event)"
    dateFormat="dd/mm/yy"
    showButtonBar="true"
    [showIcon]="true"
    [readonlyInput]="true"
   
    appendTo="body"
    styleClass="filter-datepicker"
  ></p-datePicker>
</div>

<!-- text filter (NEW) -->
<input
  *ngIf="config.type === 'text'"
  type="text"
  pInputText
  [(ngModel)]="value"
  (input)="onValueChange(value)"
  placeholder="{{ config.label || 'Enter text...' }}"
  class="filter-class p-inputtext"
/>
